import { Fragment } from 'react'

import {
  Box, NavigationLinkGroup, NestedNavigation, Text,
} from '@domain-group/suit-theme'

import useCurrentUser from '@hooks/useCurrentUser'

import generateNavigationItems from './utils/generateNavigationItems'

import NewsDeskSidebarDeadlines from '../NewsDeskSidebarDeadlines'

const NewsDeskNavigation = (props: { pageFilters: { days_from_now?: string }}) => {
  const { pageFilters } = props

  const { isAdmin } = useCurrentUser()

  const navigationItems = generateNavigationItems()

  return (
    <NestedNavigation>
      <Box flexDirection="column" flexShrink="0">
        <Box alignItems="center" padding="large" borderBottom="1px solid" borderColor="lineColor">
          <Text fontSize="large">News Desk</Text>
        </Box>

        <Box flexDirection="column" padding="large" borderBottom="1px solid" borderColor="lineColor">
          {navigationItems.sections?.map(section => (
            <Fragment key={section.key}>
              {section.items?.map(item => (
                <NavigationLinkGroup key={item.key} link={item} secondaryNav sidebarMaximized />
              ))}
            </Fragment>
          ))}
        </Box>
      </Box>

      {/*
       // @ts-expect-error TS2322 */}
      {isAdmin && <NewsDeskSidebarDeadlines pageFilters={pageFilters} /> }
    </NestedNavigation>
  )
}

export default NewsDeskNavigation
